import ReactGA from 'react-ga4';

const initializeAnalytics = () => {
  ReactGA.initialize('G-F76WE7DY0V');
};

export default initializeAnalytics;